﻿/*
 * Purpose: Switch between Login, Register, and Forgot Password layouts based on hook state.
 * Boundary: Delegates to specific layouts; no business logic.
 * Invariants:
 * - Consumes object h from useAuthForm with state and handlers.
 * - ASCII only; no Unicode in comments or strings
 */
// Imports
import LoginLayout from './layouts/authform-login-layout';
import RegisterLayout from './layouts/authform-register-layout';
import ForgotPasswordLayout from './layouts/authform-forgotpassword-layout';

// Component AuthFormLayout:
// Switches between login, register, and forgot password layouts
export default function AuthFormLayout(h) {
    if (h.mode === 'forgot-password') {
        return (
            <div>
                {/* Tap-out (X) */}
                <button
                    type="button"
                    aria-label="Close forgot password"
                    onClick={() => h.setMode('login')}
                    className="absolute top-2 right-2 h-8 w-8 rounded-full hover:bg-neutral-800/60 focus:outline-none"
                    title="Close"
                >
                    X
                </button>
                <ForgotPasswordLayout {...h} />
            </div>
        );
    }
    return h.isRegister ? <RegisterLayout {...h} /> : <LoginLayout {...h} />;
}